import React, { FC, useEffect } from 'react';
import classNames from 'classnames';
import styles from './assets/serviceType-create-screen.module.scss';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ServiceTypeForm';
import { routes } from 'src/navigation';
import Breadcrumbs from 'src/components/Breadcrumbs';
import { QueryParams } from '../../../../../../types/grid';
import { RouteComponentProps } from 'react-router';

export interface StateProps {
    inProgress: boolean;
    providers: { title: string; id: number | string }[];
}

export interface DispatchProps {
    getProviders: (params: QueryParams) => void;
}

interface RouteParams {}

export type OwnProps = RouteComponentProps<RouteParams>;

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ServiceTypeCreateScreen: FC<Props> = (props: Props) => {
    //const { providers, inProgress, getProviders } = props;

    //useEffect(() => {
    //    getProviders({ page: 1, itemsPerPage: 9000 });
    // eslint-disable-next-line
    //}, [getProviders]);

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'SERVICE TYPES', path: routes.SERVICE_TYPES_LIST },
                    { name: `ADD NEW SERVICE TYPE`, path: '' },
                ]}
            />
            <div className={classNames(styles.wrapForm)}>
                <Form initialValues={{ isEvaluation: false, title: '' }} />
            </div>
        </AdminLayout>
    );
};

export default ServiceTypeCreateScreen;
